import axios from 'axios'
import store from '../store/index'

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';
axios.defaults.baseURL = process.env.VUE_APP_ROOT_API || "/api/v1/";
axios.defaults.withCredentials = true;

export const HTTP = axios.create({
    baseURL: process.env.VUE_APP_ROOT_API || "/api/v1/",
    headers: {
        // Authorization: `JWT ${store.getters.jwt}`,
        // "X-Current-Project": store.getters.currentProjectId,
        "Content-Type": "application/json",
    },
    xhrFields: {
        withCredentials: true,
    },
});
HTTP.interceptors.request.use(function (config) {
     const token = store.getters.jwt;
    const projectId = store.getters.currentProjectId;
// console.log(token, projectId)
    if (token) {
        config.headers.Authorization = `JWT ${token}`;
    }
//
    if (projectId) {
        config.headers["X-Current-Project"] = projectId;
    }

    store.dispatch('loader', true);
    return config;
}, function (error) {
    store.dispatch('loader', false);
    return Promise.reject(error);
});
HTTP.interceptors.response.use(function (response) {
    store.dispatch('loader', false);
    return response;
}, function (error) {
    if (error.message === "canceled"){
        console.log("Request cancel")
        return Promise.resolve({
            data: [],
            _cancelled: true
        });
    }
    else if (error.response.status === 404) {
        // store.dispatch("go_404");
    }
    else if (error.response.status === 403) {
        // store.dispatch("go_403");
    }
    else if (error.response.status === 401) store.dispatch('logout');
    store.dispatch('loader', false);

    return Promise.reject(error);
});
export default HTTP
